(function () {
  var selectors = {
    section: '[data-section-type="product"][data-section-id]',
    optionRoot: '[data-unlimited-variant-options]',
    selectedVariantJson: '[data-selected-variant-json]',
    form: '[data-unlimited-product-form] form',
    idInput: 'input[name="id"]',
    addButton: '[data-add-to-cart]',
    addButtonText: '[data-add-to-cart-text]',
    buttonPrice: '[data-button-price]',
    priceBlock: '.product__block__price',
    remainingBlock: '.product__block__remaining',
    productFormWrapper: '[data-product-form-wrapper]',
    optionValueLabel: '[data-option-value]',
    slideshow: '[data-product-slideshow]'
  };

  var latestRequestId = 0;

  function parseJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node || !node.textContent.trim()) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('[product-unlimited-variants] Invalid JSON', error);
      return null;
    }
  }

  function getSection(element) {
    return element && element.closest(selectors.section);
  }

  function getSelectedOptionValueIds(section) {
    var ids = [];
    var wrappers = section.querySelectorAll('[data-option-position]');
    var hasMissingId = false;

    wrappers.forEach(function (wrapper) {
      var radio = wrapper.querySelector('input[type="radio"][data-option-value-id]:checked');
      var hidden = wrapper.querySelector('input[data-current-option-value-id]');
      var id = radio ? radio.getAttribute('data-option-value-id') : hidden && hidden.getAttribute('data-current-option-value-id');
      if (id) {
        ids.push(id);
      } else {
        hasMissingId = true;
      }
    });

    if (hasMissingId || ids.length !== wrappers.length) {
      console.warn('[product-unlimited-variants] Missing option value IDs; skipping option_values request.');
      return [];
    }

    return ids;
  }

  function getSelectedProductUrl(section, changedElement) {
    if (changedElement && changedElement.getAttribute('data-product-url')) {
      return changedElement.getAttribute('data-product-url');
    }

    var selected = section.querySelector('[data-option-value-id]:checked, [data-popout-option][aria-current="true"]');
    return selected && selected.getAttribute('data-product-url');
  }

  function setLoading(section, isLoading) {
    section.querySelectorAll(selectors.addButton).forEach(function (button) {
      if (isLoading) {
        button.setAttribute('data-was-disabled', button.disabled ? 'true' : 'false');
        button.disabled = true;
      } else {
        button.disabled = button.getAttribute('data-was-disabled') === 'true';
        button.removeAttribute('data-was-disabled');
      }
      button.classList.toggle('loading', isLoading);
    });
  }

  function formatMoney(cents) {
    var currency = window.themeCurrency || (window.themeVendor && window.themeVendor.themeCurrency);
    var themeSettings = window.theme || {};

    if (currency && currency.formatMoney) {
      var formatted = currency.formatMoney(cents, themeSettings.moneyFormat);
      return themeSettings.settings && themeSettings.settings.currency_code_enable
        ? formatted + ' ' + themeSettings.currencyCode
        : formatted;
    }

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, themeSettings.moneyFormat);
    }

    if (window.Intl && themeSettings.currencyCode) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: themeSettings.currencyCode
      }).format(cents / 100);
    }

    return String(cents);
  }

  function updateButton(section, variant) {
    var wrapper = section.querySelector(selectors.productFormWrapper);
    var addText = window.theme && window.theme.strings ? window.theme.strings.addToCart : 'Add to cart';
    var soldOutText = window.theme && window.theme.strings ? window.theme.strings.soldOut : 'Sold out';
    var unavailableText = window.theme && window.theme.strings ? window.theme.strings.unavailable : 'Unavailable';

    section.querySelectorAll(selectors.idInput).forEach(function (input) {
      input.value = variant && variant.id ? String(variant.id) : '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    section.querySelectorAll(selectors.addButton).forEach(function (button) {
      button.disabled = !(variant && variant.available);
      button.setAttribute('aria-label', variant ? (variant.available ? addText : soldOutText) : unavailableText);
      button.classList.remove('loading');
    });

    section.querySelectorAll(selectors.addButtonText).forEach(function (node) {
      node.textContent = variant ? (variant.available ? addText : soldOutText) : unavailableText;
    });

    section.querySelectorAll(selectors.buttonPrice).forEach(function (node) {
      node.innerHTML = variant && variant.price != null ? formatMoney(variant.price) : '';
    });

    if (wrapper) {
      wrapper.classList.toggle('variant--soldout', !!(variant && !variant.available));
      wrapper.classList.toggle('variant--unavailable', !variant);
    }
  }

  function replaceFromRenderedSection(section, renderedSection) {
    var currentOptions = section.querySelector(selectors.optionRoot);
    var nextOptions = renderedSection.querySelector(selectors.optionRoot);
    if (currentOptions && nextOptions) currentOptions.replaceWith(nextOptions);

    var currentPrice = section.querySelector(selectors.priceBlock);
    var nextPrice = renderedSection.querySelector(selectors.priceBlock);
    if (currentPrice && nextPrice) currentPrice.replaceWith(nextPrice);

    var currentRemaining = section.querySelector(selectors.remainingBlock);
    var nextRemaining = renderedSection.querySelector(selectors.remainingBlock);
    if (currentRemaining && nextRemaining) currentRemaining.replaceWith(nextRemaining);

    var variant = parseJson(section, selectors.selectedVariantJson);
    updateButton(section, variant);

    section.querySelectorAll(selectors.optionValueLabel).forEach(function (label) {
      var wrapper = label.closest('[data-option-position]');
      var checked = wrapper && wrapper.querySelector('input[type="radio"]:checked');
      var hidden = wrapper && wrapper.querySelector('input[data-current-option-value-id]');
      label.textContent = checked ? checked.value : hidden ? hidden.value : label.textContent;
    });

    if (variant && variant.featured_media && variant.featured_media.id) {
      var slideshow = section.querySelector(selectors.slideshow);
      if (slideshow) {
        slideshow.dispatchEvent(new CustomEvent('theme:image:change', {
          detail: { id: variant.featured_media.id }
        }));
      }
    }

    section.dispatchEvent(new CustomEvent('theme:variant:change', {
      detail: { variant: variant },
      bubbles: true
    }));

    return variant;
  }

  function renderSelection(section, changedElement) {
    var ids = getSelectedOptionValueIds(section);
    if (!ids.length) return;

    var sectionId = section.getAttribute('data-section-id');
    var requestId = ++latestRequestId;
    var selectedProductUrl = getSelectedProductUrl(section, changedElement);
    var url = selectedProductUrl ? new URL(selectedProductUrl, window.location.origin) : new URL(window.location.href);
    url.searchParams.set('option_values', ids.join(','));
    url.searchParams.set('section_id', sectionId);
    url.searchParams.delete('variant');

    setLoading(section, true);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Section render failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (requestId !== latestRequestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var variant = replaceFromRenderedSection(section, doc);
        var historyUrl = selectedProductUrl ? new URL(selectedProductUrl, window.location.origin) : new URL(window.location.href);
        historyUrl.searchParams.set('option_values', ids.join(','));
        historyUrl.searchParams.delete('variant');
        window.history.replaceState({ path: historyUrl.toString() }, '', historyUrl.toString());
        updateButton(section, variant);
        if (changedElement && changedElement.id) {
          var focused = document.getElementById(changedElement.id);
          if (focused) focused.focus();
        }
      })
      .catch(function (error) {
        if (requestId !== latestRequestId) return;
        console.warn('[product-unlimited-variants] Could not load selected option values', error);
        setLoading(section, false);
      });
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-popout-option][data-option-value-id]');
    if (!option) return;
    var wrapper = option.closest('[data-option-position]');
    var hidden = wrapper && wrapper.querySelector('input[data-current-option-value-id]');
    if (hidden) {
      hidden.setAttribute('data-current-option-value-id', option.getAttribute('data-option-value-id'));
      if (option.getAttribute('data-product-url')) {
        hidden.setAttribute('data-product-url', option.getAttribute('data-product-url'));
      } else {
        hidden.removeAttribute('data-product-url');
      }
      hidden.value = option.getAttribute('data-value') || option.textContent.trim();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name^="options"]')) return;
    var section = getSection(event.target);
    if (!section || !section.querySelector(selectors.optionRoot)) return;
    renderSelection(section, event.target);
  }, true);
})();
